__turbopack_context__.v({
  "actionBtn": "SidebarAffiliation-module__Ft5HuW__actionBtn",
  "amount": "SidebarAffiliation-module__Ft5HuW__amount",
  "amountRow": "SidebarAffiliation-module__Ft5HuW__amountRow",
  "card": "SidebarAffiliation-module__Ft5HuW__card",
  "icon": "SidebarAffiliation-module__Ft5HuW__icon",
  "left": "SidebarAffiliation-module__Ft5HuW__left",
  "title": "SidebarAffiliation-module__Ft5HuW__title",
});
